import { isEasterHoliday, isWinterHoliday } from '@/data/DateTimeUtil';
import { Image } from '@chakra-ui/react';

const Banner = ({ relativeTop }: { relativeTop: number }) => {
    const now = new Date();

    return (
        <>
            {isWinterHoliday(now) && <Image boxSize='100%' objectFit='cover' src='/images/holidays/new-year.webp' alt='Christmas' position='relative' top={`${relativeTop}px`} />}
            {isEasterHoliday(now) && <Image boxSize='100%' objectFit='cover' src='/images/holidays/easter.webp' alt='Easter' position='relative' top={`${relativeTop}px`} />}
        </>
    );
}

export default Banner;